type Protocol =
  | "ws"
  | "wss"
  | "mqtt"
  | "mqtts"
  | "tcp"
  | "ssl"
  | "wx"
  | "wxs"
  | undefined;

interface Server {
  clientId: string;
  host: string;
  port: number;
  protocol: Protocol;
}

/**
 * Browsers block plain `ws://` connections from a page served over `https://`
 * (mixed content), so the websocket protocol has to follow the page protocol.
 */
export const WS_PROTOCOL: Protocol =
  window.location.protocol === "https:" ? "wss" : "ws";

export const SERVERS: Array<Server> = [
  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: window.location.hostname,
    port: 8883,
    protocol: WS_PROTOCOL,
  },
  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: "hefring.local",
    port: 8883,
    protocol: WS_PROTOCOL,
  },
  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: "hefring",
    port: 8883,
    protocol: WS_PROTOCOL,
  },

  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: "172.16.6.0",
    port: 8883,
    protocol: WS_PROTOCOL,
  },
  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: "172.17.0.1",
    port: 8883,
    protocol: WS_PROTOCOL,
  },
  // Loopback stays on plain `ws`: browsers treat loopback as a trustworthy
  // origin and exempt it from mixed content blocking, and no certificate is
  // ever valid for 127.0.0.1, so `wss` here could only fail.
  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: "127.0.1.1",
    port: 8883,
    protocol: "ws",
  },
  {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: "127.0.0.1",
    port: 8883,
    protocol: "ws",
  },
];

export const DEV_SERVERS: Array<Server> = [
  {
    clientId: "local_dev_" + Math.floor(Math.random() * 1e8),
    host: "localhost",
    port: 9001,
    protocol: "ws",
  },
];

// Parses a broker URL like "ws://192.168.1.10:8883" into a Server
export const serverFromUrl = (url: string): Server => {
  const parsed = new URL(url);
  return {
    clientId: "frontend_" + Math.floor(Math.random() * 1e8),
    host: parsed.hostname,
    port: parseInt(parsed.port) || 8883,
    protocol: (parsed.protocol.replace(":", "") as Protocol) || WS_PROTOCOL,
  };
};
